<template>
  <div class="tab_view_container">
    <div v-if="showRateLimitMask" class="rate_limit_mask">
      <img class="rate_limit_img" :src="rateLimitImg" />
      <p class="rate_limit_text">{{ $t('当前使用人数过多,请稍后再试') }}</p>
      <button class="rate_limit_btn" @click="handleRateLimitRetry">{{ $t('重试') }}</button>
    </div>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
    </router-view>

    <div class="placeholer"></div>

    <ul v-if="filterTabOptions.length > 0" class="tab_wrapper">
      <router-link
        :to="getLink(item)"
        custom
        v-slot="{ navigate, isExactActive }"
        v-for="(item, index) in filterTabOptions"
        :key="index"
        :replace="item.defaultCode !== 'live'"
      >
        <li class="tab_item" @click="navigateHandle(item, navigate)">
          <img :src="item.choseImgUrl" class="item_img" v-show="isExactActive" />
          <img :src="item.defaultImgUrl" class="item_img" v-show="!isExactActive" />
          <p class="item_text" :class="{ item_text_active: isExactActive }">{{ item.name }}</p>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { watch, computed, onActivated, ref, getCurrentInstance, type ComponentInternalInstance } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter, useRoute } from 'vue-router'
import APIRequest from '@/api'
import { useThemeColor } from '@/utils/theme'
import { useUsersStore } from '@/stores/users'
import { useSystemStore } from '@/stores/system'
import { TabData } from '@/api/Models/AppTabs'
import qs from 'qs'
import { skipExternalMall, isWeimobMall } from '@/utils/navigation'
// import { isWechat } from '@/utils/weixin'
import { useAuthStore } from '@/stores/login'

const { proxy } = getCurrentInstance() as ComponentInternalInstance
const tabsRateLimited = ref(false)
const globalRateLimited = ref(false)
const rateLimitImg = require('@/assets/images/empty/error.png')
const showRateLimitMask = computed(() => {
  const loginPaths = ['/login', '/enterpriseLogin', '/phoneLogin', '/multiAccount']
  const isLoginPage = loginPaths.some((path) => route.path.startsWith(path))
  return !isLoginPage && (tabsRateLimited.value || globalRateLimited.value)
})

const navigateHandle = (item: TabData, navigate: () => void) => {
  if (isWeimobMall(item)) {
    skipExternalMall(item.jumpUrl)
    return ''
  }
  if (item.jumpUrl && item.jumpUrl.indexOf('#') > -1) {
    window.location.href = item.jumpUrl
    // if (isFeishu) {
    //   if (item.jumpUrl) {
    //     window.location.href = item.jumpUrl
    //   } else {
    //     navigate(getLink(item))
    //   }
    // } else {
    //   navigate(getLink(item))
    // }
  } else {
    navigate()
  }
}

const route = useRoute()
const getLink = (item: TabData) => {
  const code = item.defaultCode
  if (code === 'home') {
    return '/'
  }
  if (code === 'course') {
    return `/course?${qs.stringify(route.query)}`
  }
  if (code === 'community') {
    return '/community'
  }
  if (code === 'live') {
    return '/liveStream'
  }
  if (code === 'mine') {
    return '/my'
  }
  if (code === 'welfareMall') {
    return '/shopIndexTab'
  }
  if (code === 'lecturer') {
    return '/lecturerCenterTab'
  }
  if (code === 'task') {
    return '/taskTab'
  }
  if (code === 'study') {
    return '/myStudyTab'
  }
  // 报名
  if (code === 'signUp') {
    return '/applyCenterTab'
  }
  if (code === 'project') {
    return '/myTrainingTab'
  }
  if (code === 'exam') {
    return '/examPractiseTab'
  }
  if (code === 'survey') {
    return '/mySurveyTab'
  }
  // 面授
  if (code === 'offlineTrain') {
    return '/faceTeachingTab'
  }
  if (code === 'team') {
    return '/teamStudyListTab'
  }
  if (code === 'message') {
    return '/newsTab'
  }
  if (code === 'teaching') {
    return '/teachManage/TeachManageListTab'
  }
  // 管理员工作台入口
  if (code === 'workBench') {
    return '/workbenchTab'
  }

  if (!code && item.jumpUrl) {
    if (item.jumpUrl?.indexOf('web') > -1) {
      // window.location.href = item.jumpUrl
      return `/tabWebview/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
    } else {
      const str = process.env.VUE_APP_ENV === 'prod' ? 'share.sandstalk.com/s' : 'sands-system/s'
      if (item.jumpUrl?.indexOf(str) > -1) {
        // return `/tabCommonView?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
        return `/tabCommonView/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
      } else {
        // return `/tabWebview?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
        return `/tabWebview/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
      }
    }
  }
  return ''
}

const themeColor = useThemeColor()

const router = useRouter()
const usersStore = useUsersStore()
const authStore = useAuthStore()
const { collegeId, allTabOptions } = storeToRefs(usersStore)

const filterTabOptions = computed(() => {
  return filterByPermissions(
    allTabOptions.value.filter((item: TabData) => {
      // if (isWeimobMall(item) && isWechat) {
      //   return false
      // }
      return true
    })
  )
})
const { setTabOptions, setAllTabOptions } = usersStore

const filterByPermissions = (navigations: TabData[]) => {
  return navigations.filter((item) => {
    if (item.defaultCode === 'team' && authStore?.userAuth?.teamLearningLabel !== 1) {
      return false
    }
    if (item.defaultCode === 'teaching' && authStore?.userAuth?.teachingMgtLabel !== 1) {
      return false
    }
    if (item.defaultCode === 'workBench' && authStore?.userAuth?.workbenchLabel !== 1) {
      return false
    }
    return true
  })
}

const getTabs = async () => {
  const { code, data } = await APIRequest.Home.postAppTabs({
    clientType: 3,
    collegeId: collegeId.value === '-1' ? '' : collegeId.value
  })
  if (code === 429) {
    tabsRateLimited.value = true
    proxy?.$bus.emit('home_rate_limited')
    return
  }
  if (code === 1) {
    tabsRateLimited.value = false
    const navigations = data.navigations || []
    setAllTabOptions(navigations)
    let navigationsList: TabData[] = []
    navigationsList = filterByPermissions(navigations)
    setTabOptions(navigationsList)
    if (route.name !== 'home') {
      return
    }
    navigations.forEach((item) => {
      if (item.isDefaultPage === 1) {
        router.replace(getLink(item))
      }
    })
  } else {
    usersStore.resetState()
  }
}

proxy?.$bus.on('home_rate_limit_retry', () => {
  tabsRateLimited.value = false
  getTabs()
})

const systemStore = useSystemStore()
const { lang } = storeToRefs(systemStore)
onActivated(() => {
  const needGetTabs = sessionStorage.getItem('needGetTabs')
  if (needGetTabs) {
    if (!tabsRateLimited.value) {
      getTabs()
    }
    sessionStorage.removeItem('needGetTabs')
  }
})
watch(
  [collegeId, lang],
  () => {
    if (tabsRateLimited.value) return
    getTabs()
  },
  {
    immediate: true
  }
)

const handleRateLimitRetry = () => {
  tabsRateLimited.value = false
  globalRateLimited.value = false
  proxy?.$bus.emit('home_rate_limit_retry')
  getTabs()
}
</script>
<script lang="ts">
export default {
  name: 'tab'
}
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.tab_view_container {
  .placeholer {
    height: 50px;
    padding-bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
    box-sizing: content-box;
  }
}

.rate_limit_mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(50px + env(safe-area-inset-bottom));
  bottom: calc(50px + constant(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f7;
  z-index: 1999;
}

.rate_limit_img {
  width: 178px;
  height: 178px;
}

.rate_limit_text {
  margin-top: 8px;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: center;
}

.rate_limit_btn {
  margin-top: 16px;
  padding: 4px 18px;
  border-radius: 16px;
  border: 1px solid #c9c9c9;
  background: #ffffff;
  color: #1a1a1a;
  font-size: 14px;
}

.tab_wrapper {
  width: 100%;
  height: 50px;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  box-sizing: content-box;
  left: 0;
  bottom: 0;
  display: flex;
  .border_1px_t;
  position: fixed;
  z-index: 2000;
  background-color: @contentBackground;

  .tab_item {
    flex-direction: column;
    flex: 1;
    .flex_center;

    .item_img {
      width: 24px;
      height: 24px;
    }

    .item_text {
      color: @textSecondary99;
      font-size: 12px;
      .text_etc;
    }

    .item_text_active {
      color: v-bind(themeColor);
    }
  }
}
</style>
